import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { SKIN_THEMES, FONT_UI, getThemeVars } from "./constants";

export default function Layout({
  children,
  dashboardData = {},
  routePage,
  activePage = "",
  activeMenu = "",
}) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [skinId, setSkinId] = useState(
    () => localStorage.getItem("skinTheme") || "navy"
  );
  const skin = SKIN_THEMES.find((s) => s.id === skinId) || SKIN_THEMES[0];

  // Recompute CSS variables whenever the theme changes
  const themeVars = useMemo(() => getThemeVars(skin), [skin]);

  const handleSkinChange = (id) => {
    setSkinId(id);
    localStorage.setItem("skinTheme", id); // persisted -> survives reload
  };

  const handleLogout = () => {
    ["token","authToken","isLoggedIn","userData","company_name","licensedFor",
     "admin_active","company_address","company_phone","admin_email","company_logo","user_map"]
      .forEach((k) => localStorage.removeItem(k));
    navigate("/");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--page-bg)",
        color: "var(--text-primary)",
        fontFamily: FONT_UI,
        ...themeVars, // <-- injects all --accent / --page-bg / etc as CSS vars on this subtree
      }}
    >
      <Sidebar
        skin={skin}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        routePage={routePage || "/route-master"}
        onLogout={handleLogout}
        activePage={activePage}
        activeMenu={activeMenu}
      />

      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column", marginLeft: "270px" }}
        className="layout-main-col"
      >
        <Header
          skin={skin}
          skinId={skinId}
          onSkinChange={handleSkinChange}
          dashboardData={dashboardData || {}}
          onLogout={handleLogout}
          setSidebarOpen={setSidebarOpen}
        />

        <main style={{ flex: 1, padding: "28px 28px" }} className="layout-main-pad">
          {children}
        </main>
      </div>

      <style>{`
        @media(max-width:1024px){
          .layout-main-col{ margin-left:0 !important; }
          .layout-main-pad{ padding:20px 16px !important; }
        }
      `}</style>
    </div>
  );
}